import apiSlice from './ApiSlice';

export const transcationServiceApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // get all order dates
    getAllTranscations: builder.query({
      providesTags: ["offline-order"],
      query: (body: PaginationPayloadType) => {
        return {
          url: "/transaction",
          method: "POST",
          body,
        };
      },
    }),
    // ****  RECEIPT Guest
    getSingleByIdTranscation: builder.query({
      providesTags: ["offline-order"],
      query: (id: any) => ({
        url: `/transaction/${id}`,
        method: "get",
      }),
    }),
    // ****  RECEIPT Guest
    getSingleByIdTranscationTotal: builder.query({
      providesTags: ["offline-order"],
      query: (id: any) => ({
        url: `/transaction/${id}/order-total`,
        method: "get",
      }),
    }),
  }),
});

export const { useGetAllTranscationsQuery, useGetSingleByIdTranscationQuery, useGetSingleByIdTranscationTotalQuery } = transcationServiceApi;